/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type MappaturaAllarmiType =
  (typeof MappaturaAllarmiType)[keyof typeof MappaturaAllarmiType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MappaturaAllarmiType = {
  Bitmask: "Bitmask",
  Equality: "Equality",
} as const;
